<template>

  <div class="video"
       id="tablevideo"
       :style="`width:${700*$store.state.ratio.width}px;height:${650*$store.state.ratio.height}px;margin-left:${43*$store.state.ratio.height}px`">
    <div id="flashContent"></div>
  </div>

</template>
<script>
import swfobject from "../../assets/js/swfobject.js";
import FABridge from "../../assets/js/FABridge.js";
// 引入接口
import { getAreaPage_API, getEquipments_API } from '../common/video'
import setting from '../../views/system/setting'
let carousel = setting.carousel + 10000
export default {
  components: {},
  data () {
    return {
      isFlashInstalled: false,  // swj初始化
      areaIdx: "",  // 选购中的地址序号
      areaList: [
        { "id": 3, "areaNo": "4", "areaName": "333", "isValid": true }
      ],
      videoIdx: "",  // 选中视频的序号
      videoList: [
        { "id": 3, "code": "4", "areaId": 3, "name": "sb4v", "type": 0, "isValid": true, "videoUrl": "sss4" },
        { "id": 2, "code": "3", "areaId": 3, "name": "设备50148", "type": 0, "isValid": true, "videoUrl": "rtmp://dev.svideo.com.cn/myapp" }
      ],
      videoNum: 4,  // 窗口数
      targetIdx: 1,  // 窗口序号
      searchParams: {
        isValid: 1,
        // isValid: 1,
        currentPage: 1,
        pageSize: 100
      },
      areaLoading: false,
      videoLoading: false
    };
  },
  mounted () {
    this.initSwfData();
    // this.getAreaData(this.searchParams)
    this.getVideoData()


  },

  methods: {
    clickListItem (id) {

    },
    videoChange (val) {
      // console.log(val)
      this.videoIdx = val
    },
    areaChange (val) {
      // console.log(val)
      this.areaIdx = val
      this.videoList = []
      this.videoIdx = ''
      this.getVideoData({
        areaId: this.areaList[val].id,
        ...this.searchParams
      })
    },
    // 目标窗体
    targetIdxChange (val) {
      if (val <= this.videoNum && val >= 1) {
        this.targetIdx = parseInt(val)
      } else {
        this.targetIdx = 1
      }
    },
    // 获取数据
    getAreaData (searchParams) {
      this.areaLoading = true;
      getAreaPage_API(searchParams).then(res => {
        this.areaList = res.data;
        this.areaLoading = false;
      }).
        catch(() => {
          this.areaLoading = false;
        })
    },
    // 获取数据
    getVideoData (searchParams) {
      let self = this
      this.videoLoading = true;
      getEquipments_API(searchParams).then(res => {
        this.videoList = res.data.data;
        this.videoLoading = false;
        setTimeout(() => {
          this.openAllVideo(self.videoList)
        }, carousel)
      }).
        catch(() => {
          this.videoLoading = false;
        })
    },
    // adobe下载
    rvalue () {
      var pageHost =
        document.location.protocol == "https:" ? "https://" : "http://";
      var imgv =
        "<img src='" +
        pageHost +
        "www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash player' />";
      return (
        "<a href='http://www.adobe.com/go/getflashplayer'>" + imgv + "</a>"
      );
    },
    // 初始化swf
    initSwfData () {
      var isFlashInstalled =
        (navigator.plugins && navigator.plugins["Shockwave Flash"]) ||
        (this.ActiveXObject &&
          !!new ActiveXObject("ShockwaveFlash.ShockwaveFlash"));
      //alert(isFlashInstalled);
      //   var vhtml = document.getElementById("tablevideo");
      //   var r = vhtml.insertRow(0);
      //   var onecell = r.insertCell(0);
      //   onecell.height = 576;
      //   console.log(isFlashInstalled)
      if (!isFlashInstalled) {
        this.$message.warning("请安装flash player后，打开flash权限");
        return;
      }
      //   var onecell = document.getElementById("tablevideo")
      var ip = "";
      var hlsip = "http://211.144.76.43:82";
      if (isFlashInstalled) {
        this.isFlashInstalled = true;
        // onecell.innerHTML =
        //   "<div id='flashContent'>" +
        //   "<p>" +
        //   "To view this page ensure that Adobe Flash Player version " +
        //   "11.1.0 or greater is installed. " +
        //   "</p>" +
        //   this.rvalue() +
        //   "</div>" +
        //   "<noscript>" +
        //   "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000' width='100%' height='576' id='WebAPI3'>" +
        //   "<param name='movie' value='" +
        //   ip +
        //   "/WebAPI5.swf' />" +
        //   "<param name='quality' value='high' />" +
        //   "<param name='bgcolor' value='#ffffff' />" +
        //   "<param name='allowScriptAccess' value='always' />" +
        //   "<param name='allowFullScreen' value='true' />" +
        //   "<param name='allowNetworking' value='all'>" +
        //   "<!--[if !IE]>-->" +
        //   "<object type='application/x-shockwave-flash' data='" +
        //   ip +
        //   "/WebAPI5.swf' width='100%' height='576'>" +
        //   "<param name='quality' value='high' />" +
        //   "<param name='bgcolor' value='#ffffff' />" +
        //   "<param name='allowScriptAccess' value='always' />" +
        //   "<param name='allowFullScreen' value='true' />" +
        //   "<param name='allowNetworking' value='all'>" +
        //   "<!--<![endif]-->" +
        //   "<!--[if gte IE 6]>-->" +
        //   "<p> " +
        //   "Either scripts and active content are not permitted to run or Adobe Flash Player version" +
        //   "11.1.0 or greater is not installed." +
        //   "</p>" +
        //   "<!--<![endif]-->" +
        //   "<a href='http://www.adobe.com/go/getflashplayer'>" +
        //   "<img src='http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash Player' />" +
        //   "</a>" +
        //   "<!--[if !IE]>-->" +
        //   "</object>" +
        //   "<!--<![endif]-->" +
        //   "</object>" +
        //   "</noscript>";

        // For version detection, set to min. required Flash Player version, or 0 (or 0.0.0), for no version detection.
        var swfVersionStr = "11.1.0";
        // To use express install, set to playerProductInstall.swf, otherwise the empty string.
        var xiSwfUrlStr = "playerProductInstall.swf";

        var flashvars = {};
        flashvars.allowFullScreen = "true";
        flashvars.initcompletecb = "initok";

        var params = {};
        params.quality = "high";
        params.bgcolor = "#ffffff";
        params.allowScriptAccess = "always";
        params.allowFullScreen = "true";

        var attributes = {};
        attributes.id = "WebAPI3";
        attributes.name = "WebAPI3";
        attributes.align = "middle";

        swfobject.embedSWF(
          ip + "/WebAPI5.swf",
          "flashContent",
          "100%",
          "100%",
          swfVersionStr,
          xiSwfUrlStr,
          flashvars,
          params,
          attributes
        );

        // JavaScript enabled so display the flashContent div in case it is not replaced with a swf object.
        swfobject.createCSS("#flashContent", "display:block;text-align:left;");
        // window.onload = () => {
        //   setTimeout(() => {
        //   this.openAllVideo(this.videoList)
        // },2000)
        // }
      }
    },
    initok () {
      this.$message.success("初始化成功");
    },
    // 设置地址
    setServerIP (whichwindow, videoIdx) {
      var rtmpIP = 'rtmp://dev.svideo.com.cn/myapp'
      document.getElementById("WebAPI3").setServerIP(rtmpIP, whichwindow);
    },
    // 设置Id
    setDeviceId (whichwindow, videoIdx) {
      var did = this.videoList[videoIdx].code
      document.getElementById("WebAPI3").setDeviceId(did, whichwindow);

    },
    // 请求视频
    requestVideo (whichwindow, videoIdx) {
      document.getElementById("WebAPI3").requestVideo("requestVideoCallback", whichwindow);
    },
    requestVideoCallback (devid, result, msg) {
    },
    // 打开视频
    openVideo (targetIdx, videoIdx) {
      if (videoIdx === '') {
        // this.$message.warning('请选择监控设备')
        return
      }
      this.setServerIP(targetIdx, videoIdx)
      this.setDeviceId(targetIdx, videoIdx)
      this.requestVideo(targetIdx, videoIdx)
    },
    openAllVideo (list) {
      if (!list.length) {
        this.$message.warning('请选择带有设备的区域')
      }
      for (let i = 0; i < this.videoNum; i++) {
        if (list[i]) {
          this.openVideo(i, i)
        }
      }
    },
    // 关闭视频
    closeVideo () {
      document.getElementById("WebAPI3").closeVideo(this.targetIdx - 1);
    },
    // 操作命令
    sendCommand (op) {
      if (this.videoIdx === '') {
        this.$message.warning('请选择监控设备')
        return
      }
      var nServerip = this.videoList[this.videoIdx].videoUrl;
      var did = this.videoList[this.videoIdx].code;
      var iSpeed = 3;

      var urlxx =
        "http://" +
        nServerip +
        ":2400/api_control/controlptz?did=" +
        did +
        "&op=" +
        op +
        "&speed=" +
        iSpeed;

      this.$jsonp(urlxx, {
        callbackName: "success_jsonpCallback"
      })
        .then(json => {
          if (json[0].resultxx === "ok") {
            this.$message.success("操作成功");
          } else {
            this.$message.success(json[0].data);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("操作失败");
        });
    },
    // 视频数量
    setVideowayNumber (tNum) {
      this.videoNum = tNum
      this.targetIdx = 1
      document.getElementById("WebAPI3").setWindowNum(tNum);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../common/variable.scss";
.video {
  background-color: #000;
}
.controler-wrapper {
  align-self: flex-start;
  width: 400px;
  border: 1px solid #ccc;
}
.title {
  background-color: lightblue;
  line-height: 40px;
  text-indent: 20px;
}
.m-list {
  .line {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.list-btn {
  padding: 10px;
}
.c-list {
  .line {
    margin-bottom: 10px;
    &:last-child {
      margin: 0;
    }
  }
}
</style>
